import { call, put, takeLatest } from "redux-saga/effects";
import {
  getEmailLogsSuccess,
  getEmailLogsFailure,
  getEmailLogs,
} from "./emaillogsSlice";
import { fetchEmailLogsApi } from "./emaillogsApi";

function* fetchEmailLogsSaga(action) {
  try {
    const response = yield call(fetchEmailLogsApi, action.payload);
    if (response?.data) {
      yield put(getEmailLogsSuccess(response.data));
    } else {
      yield put(getEmailLogsFailure(response.error || "Failed to fetch logs"));
    }
  } catch (error) {
    yield put(getEmailLogsFailure(error.message));
  }
}

export function* watchEmailLog() {
  yield takeLatest(getEmailLogs.type, fetchEmailLogsSaga);
}
